/**
 * ThemeToggle — the Light/Dark switch in the top bar. Flips and persists the
 * user's explicit theme choice (overriding the device preference); the icon
 * shows the theme you'd switch TO. Reads/writes via lib/theme.
 */
import { useEffect, useState } from 'react';
import { onThemeChange, resolveTheme, toggleTheme, type Theme } from '../lib/theme.js';
import { IconMoon, IconSun } from './icons.js';
import { useI18n } from '../lib/i18n.js';

export function ThemeToggle() {
  const { t } = useI18n();
  const [theme, setThemeState] = useState<Theme>(() => resolveTheme());

  useEffect(() => onThemeChange(setThemeState), []);

  const next: Theme = theme === 'dark' ? 'light' : 'dark';
  const label = t(next === 'dark' ? 'theme.toDark' : 'theme.toLight');

  return (
    <button
      type="button"
      className="ghost theme-toggle"
      onClick={() => setThemeState(toggleTheme())}
      aria-label={label}
      title={label}
    >
      {next === 'dark' ? <IconMoon className="nav-ico" /> : <IconSun className="nav-ico" />}
    </button>
  );
}
